import axios from "axios";

export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "http://localhost:9090").replace(/\/$/, "");

export const myAxios = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});
